export class Commanding {
  id: string;
  readonly createdAt: Date;
  readonly updatedAt: Date;
  operationId: string;
  inputTasks: string;
  outputTasks: string;
  propelOrgId: string;

  constructor(params: CommandingParams) {
    this.id = params.id;
    this.updatedAt = new Date(params.updatedAt);
    this.createdAt = new Date(params.createdAt);
    this.operationId = params.operationId;
    this.inputTasks = params.inputTasks || '';
    this.outputTasks = params.outputTasks || '';
    this.propelOrgId = params.propelOrgId || '';
  }
}

export interface CommandingCreateParams {
  operationId: string;
  inputTasks?: string;
  outputTasks?: string;
}

export interface CommandingParams extends CommandingCreateParams {
  id: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  /** The org of the commanding's operation. CommandingAccess sets it on create from the writer org; callers never choose it. */
  propelOrgId?: string;
}
